export interface InvoiceSubscriptionDetails {
  start_at: string;
  end_at: string;
}

export interface InvoiceProducts {
  bids: number;
  credits: number;
  currency: string;
  id: number;
  price: string;
  price_net: string;
  qty: number;
  product: InvoiceProduct;
  details: InvoiceSubscriptionDetails;
}

export interface InvoiceProduct {
  id: number;
  title: string;
  ios_iap_product_id: number;
  discount_raw: number;
  color: string;
  featured: boolean;
  price_raw: string;
  vat: boolean;
  sku: string;
  active: boolean;
  show: boolean;
  vat_raw: string;
  currency: string;
  channel: string;
  credits: number;
  bids: number;
  categories: [];
  duration: number;
  autotopup: boolean;
  autotopup_price_raw: string;
  autotopup_nopenalty: number;
  price: string;
  price_net: string;
  vat_amount: string;
  offline_counterpart: number;
  backend: number;
  name_to_show: string;
}

export interface InvoiceBackend {
  description: string;
  has_unattended: boolean;
  id: string;
  name: string;
  onsite: boolean;
}

export enum FeeTypeBackend {
  CASH = 'cash',
  BANK = 'bank',
  STRIPE = 'stripe',
  SEPA = 'sepa',
  IOS = 'ios_iap'
}

export enum FeeTypeModel {
  FLAT = 'flat',
  PERCENT = 'percent'
}

export interface FeeType {
  backend: FeeTypeBackend;
  fee: number;
  fee_amount: number;
  fee_cap_amount: number;
  fee_type: FeeTypeModel;
  title: string;
  is_recommended: boolean;
}

/**
 * Response interface for
 * GET api/public/crm_invoices/
 */
export interface CrmInvoiceResponse {
  id: number;
  products: Array<InvoiceProducts>;
  price: string;
  price_net: string;
  total: string;
  total_net: string;
  total_vat: string;
  discount_sum: string;
  discount_sum_net: string;
  discounted: boolean;
  credits: number;
  confirmed: boolean;
  cancelled: boolean;
  payed: boolean;
  paid_date: string;
  payment_lock: boolean;
  processing: boolean;
  backend: InvoiceBackend;
  currency: string;
  is_company: boolean;
  is_private: boolean;
  is_proforma: boolean;
  job_id: string;
  notifications: Array<string>;
  created: string;
  expires: string;
  invoice: number;
  download_url: string;
  category_title: string;
  description: string;
  amount: number;
  action: string;
  invoice_url: string;
  transaction_fee: string;
  transaction_fee_without_vat: string;
  transaction_fees: Array<FeeType>;
}

/**
 * Response interface for
 * GET api/public/invoice/<invoice_id>/jobs/
 */
export interface DetailsInvoiceResponse {
  id: number;
  category?: string;
  user?: string;
  phone?: string;
  amount?: number;
}
